import type { ConditionalMetric, CustomMetric } from '../models/metric.types'

/** The authored field names module 08's catalog must be able to resolve. */
export function definedMetricFields(
  customMetrics: readonly CustomMetric[],
  conditionalMetrics: readonly ConditionalMetric[],
): ReadonlySet<string> {
  return new Set([
    ...customMetrics.map((metric) => metric.metric_name),
    ...conditionalMetrics.map((metric) => metric.name),
  ])
}
